import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { QaiButtonComponent, QaiDialogComponent, QaiLinkComponent } from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';
import { CallStoreService } from '../../../library/call-store/call-store.service';

@Component({
  host: {
    class: 'theme-light',
  },
  selector: 'app-learn-step-help-modal',
  templateUrl: './learn-step-help-modal.component.html',
  styleUrls: ['./learn-step-help-modal.component.scss'],
  standalone: true,
  imports: [QaiDialogComponent, QaiButtonComponent, QaiLinkComponent, TranslocoModule],
})
export class LearnStepHelpModalComponent implements OnChanges, OnDestroy {
  @ViewChild('dialog') dialogRef: QaiDialogComponent | undefined;

  @Input() open: boolean = false;
  @Input() title: string = '';
  @Input({ required: true }) stepType!: 'pdf' | 'video' | 'scorm';

  @Output() closed = new EventEmitter<void>();

  constructor(private callStore: CallStoreService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open']) {
      if (changes['open'].currentValue) {
        this.dialogRef?.showModal();
        this.callStore.registerModalOpen();
      } else {
        this.dialogRef?.close();
        this.callStore.registerModalClosed();
      }
    }
  }

  onClose(): void {
    this.dialogRef?.close();
    this.closed.emit();
  }

  ngOnDestroy(): void {
    if (this.open) {
      this.callStore.registerModalClosed();
    }
  }
}
